import { useMutation } from '@tanstack/react-query';

import { stripeRepo } from '@ctct/domain-layer';
import { stripeApi } from '@ctct/infrastructure-layer';

import { useAchMicroDepositsGate } from '../experiments/useAchMicroDepositsGate';
import { useMutationMemoized } from '../helpers/useMutationMemoized';

export const useUpdateSetupIntentParams = ({
  quoteId,
  paymentMethodId,
}: {
  useCase: 'payments-only' | 'billing';
  quoteId: string | null;
  paymentMethodId?: string | null;
}) => {
  const { data: paymentMethodOptions } = useAchMicroDepositsGate();

  const mutation = useMutation({
    mutationFn: ({
      useCase,
      countryCode,
      currencyCode,
      paymentMethodId: overridePaymentMethodId,
      returnUrl: overrideReturnUrl,
    }: {
      useCase: 'payments-only' | 'billing';
      countryCode: string | undefined;
      currencyCode: string | undefined;
      paymentMethodId?: string;
      returnUrl?: string;
    }) => {
      if (useCase === 'billing' && !quoteId) {
        throw new Error('Stripe quote ID is required for billing use case');
      }

      return stripeRepo.updateSetupIntentParams({
        quoteId,
        countryCode,
        currencyCode,
        paymentMethodId: overridePaymentMethodId ?? (typeof paymentMethodId === 'string' ? paymentMethodId : undefined),
        returnUrl: typeof overrideReturnUrl === 'string' ? overrideReturnUrl : stripeApi.getReturnUrl(),
        paymentMethodOptions,
      });
    },
  });

  return useMutationMemoized(mutation);
};

export type UpdateSetupIntentParamsMutation = ReturnType<typeof useUpdateSetupIntentParams>;
